<script>
export default {
  name: 'BaseExpansionPanel',
  props: {
    label: {
      type: String,
      default: ''
    },
    data: {
      type: Array,
      default() {
        return []
      }
    },
    searchFn: {
      type: Function,
      default: null
    },
    required: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      searchQuery: '',
      visibleItems: [],
      partial: 0,
      MAX_ROW_VISIBLE: 50
    }
  },
  methods: {
    loadItems() {
      const start = this.visibleItems.length
      const end = start + this.MAX_ROW_VISIBLE
      this.visibleItems = [...this.visibleItems, ...this.data.slice(start, end)]
    },
    createIntersectionObserverForSimpleTable() {
      const observer = new IntersectionObserver(
        entries => {
          for (const entry of entries) {
            if (entry.isIntersecting) {
              this.loadItems()
            }
          }
        },
        { rootMargin: '-100px' }
      )

      const lastItem = document.getElementById('intersectingMark')

      observer.observe(lastItem)
    }
  },
  watch: {
    data: {
      handler(newValue) {
        this.searchQuery = ''
        this.visibleItems = []
        this.loadItems()
        if (newValue.length > this.MAX_ROW_VISIBLE)
          this.createIntersectionObserverForSimpleTable()
        }
    }
  },
  mounted() {
    this.loadItems()
    if (this.data.length > this.MAX_ROW_VISIBLE)
      this.createIntersectionObserverForSimpleTable()
  }
}
</script>

<template>
  <v-expansion-panel>
    <v-expansion-panel-header>
      <v-row>
        <v-col cols="auto" class="justify-center align-content-center py-0">
          <span class="tertiary--text text-body-2">{{ label }}</span>
          <span v-if="required" class="asterisc"> *</span>
        </v-col>
        <v-col
          cols="auto"
          class="pr-0 py-0 justify-center align-content-center"
        >
          <v-chip-group active-class="primary--text" column>
            <slot name="chipGroup" :data="data" />
          </v-chip-group>
        </v-col>
      </v-row>
    </v-expansion-panel-header>
    <v-expansion-panel-content :eager="true">
      <v-row justify="space-around" no-gutters>
        <v-col cols="12" class="pb-0 pr-0 justify-center align-content-center">
          <v-text-field
            dense
            v-model="searchQuery"
            append-icon="mdi-magnify"
            label="Buscar"
            single-line
          ></v-text-field>
        </v-col>
        <v-col cols="12">
          <v-simple-table height="350" rounded="lg" id="simpleTable">
            <template v-slot:default>
              <thead>
                <tr>
                  <th class="text-left">
                    Seleccionar
                  </th>
                  <th class="text-left">
                    {{ label }}
                  </th>
                </tr>
              </thead>
              <tbody>
                <slot
                  name="eachRow"
                  :data="searchFn(visibleItems, searchQuery)"
                />
                <div style="padding: 5px" id="intersectingMark"></div>
              </tbody>
            </template>
          </v-simple-table>
        </v-col>
      </v-row>
    </v-expansion-panel-content>
  </v-expansion-panel>
</template>

<style scoped></style>
